// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ckh1","inner":"Form_inner__1Z_vu","range":"Form_range__1lIbR","name":"Form_name__33mND","actions":"Form_actions__2Q3k4"};